import { Nullable } from 'types';
import { regExp } from 'utilities/regExp/regExp';

const number = {
  /**
   * input: 2123  output: $2,123.00
   */
  displayCurrency(amount: number) {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  },

  /**
   * input: 32145.1234 output: $ 32,145.12
   */
  formatterCurrency: (value: Nullable<number | string>) => {
    value = `${value}`.replace(regExp.number2decimals, '$1');
    value = value ? `$ ${value}`.replace(regExp.number3Digits, ',') : '';
    return value;
  },

  /**
   * input: 12345abcdzyx./*?67890  output: 12345.67
   */
  removeNonDigits: (value: Nullable<string>) => {
    value = value ? value.replace(regExp.nonDigit, '') : '';
    value = value.replace(regExp.number2decimals, '$1');
    return value;
  },
};

export default number;
